// This is not really supported on the graphql query, but it's used internally
export const ALL = 'ALL'
